import { useMutation, useQuery } from "@tanstack/react-query";

import { externalFinalPageSettingsApi } from "./api";
import { externalFinalPageSettingsQueryOptions } from "./queryOptions";

import GetExternalFinalPageSettingsRequest = App.Http.Requests.ExternalFinalPageSetting.GetExternalFinalPageSettingsRequest;
import GetExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.GetExternalFinalPageSettingRequest;
import StoreExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.StoreExternalFinalPageSettingRequest;
import UpdateExternalFinalPageSettingRequest = App.Http.Requests.ExternalFinalPageSetting.UpdateExternalFinalPageSettingRequest;

export const useGetExternalFinalPageSettings = (offerId: string, request: GetExternalFinalPageSettingsRequest, options = {}) => {
    return useQuery({
        ...externalFinalPageSettingsQueryOptions.index(offerId, request),
        ...options,
    });
};

export const useGetExternalFinalPageSetting = (offerId: string, externalFinalPageSettingId: string, request: GetExternalFinalPageSettingRequest, options = {}) => {
    return useQuery({
        ...externalFinalPageSettingsQueryOptions.show(offerId, externalFinalPageSettingId, request),
        ...options,
    });
};

export const useStoreExternalFinalPageSettingMutation = (offerId: string) => {
    return useMutation({
        mutationFn: (request: StoreExternalFinalPageSettingRequest) => externalFinalPageSettingsApi.store(offerId, request),
    });
};

export const useUpdateExternalFinalPageSettingMutation = (offerId: string, externalFinalPageSettingId: string) => {
    return useMutation({
        mutationFn: (request: UpdateExternalFinalPageSettingRequest) => externalFinalPageSettingsApi.update(offerId, externalFinalPageSettingId, request),
    });
};

export const useDestroyExternalFinalPageSettingMutation = (offerId: string, externalFinalPageSettingId: string) => {
    return useMutation({
        mutationFn: () => externalFinalPageSettingsApi.destroy(offerId, externalFinalPageSettingId),
    });
};